import { render, staticRenderFns } from "./RevenueTrend.vue?vue&type=template&id=60a1f77b"
import script from "./RevenueTrend.vue?vue&type=script&lang=js"
export * from "./RevenueTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports